export default {
    url: 'support/warranty',
    include: ['us', 'za', 'ca', 'uk', 'au', 'de', 'fr', 'it', 'es', 'cis'],
};
